import React from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/JK_Resume_2026.pdf";
import { AiOutlineDownload } from "react-icons/ai";

function ResumeNew() {
  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            rel="noreferrer"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        <Row className="resume" style={{ justifyContent: "center" }}>
          <object
            data={pdf}
            type="application/pdf"
            aria-label="Jignesh Kotadiya resume"
            style={{
              width: "min(850px, 100%)",
              height: "90vh",
              border: "none",
              borderRadius: "8px",
            }}
          >
            <iframe
              src={pdf}
              title="Jignesh Kotadiya resume"
              style={{ width: "100%", height: "90vh", border: "none" }}
            />
            <p style={{ color: "white" }}>
              Your browser can't display the PDF inline.&nbsp;
              <a href={pdf} target="_blank" rel="noreferrer" style={{ color: "#c084f5" }}>
                Download the CV
              </a>
              &nbsp;instead.
            </p>
          </object>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            rel="noreferrer"
            style={{ maxWidth: "250px", marginTop: "20px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
